import React from "react";
import UnderlineLinkAtm from "../../../../atoms/UnderlineLinkAtm";
import PushOrg from "../../../../organisms/PushOrg";
var CtaLink = function CtaLink(_ref) {
  var text = _ref.text,
    isFileUpload = _ref.isFileUpload,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 3
  }, /*#__PURE__*/React.createElement(UnderlineLinkAtm, {
    href: "#",
    title: text,
    typography: isFileUpload ? "tiny2" : "xsmall1",
    color: isFileUpload ? "dark" : "secondaryLight",
    onClick: onClick
  }, text));
};
export default CtaLink;